var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAutofast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_16",
    "data-name": "Grupo 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 165.281,
    height: 65.856,
    viewBox: "0 0 165.281 65.856",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_45",
    "data-name": "Rect\\xE1ngulo 45",
    width: 165.281,
    height: 65.856,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_55",
    "data-name": "Trazado 55",
    d: "M24.917,5.226h2.348l8.489,18.665H32.709L30.645,19.16h-9.16l-2.065,4.731H16.5Zm4.7,11.528L26.078,8.572l-3.561,8.183Z",
    transform: "translate(-10.248 -3.245)",
    fill: "#212121"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17",
    "data-name": "Grupo 17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16-2",
    "data-name": "Grupo 16",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_56",
    "data-name": "Trazado 56",
    d: "M83.343,5.226h2.812V15.761a9.885,9.885,0,0,1-1.019,4.705,6.8,6.8,0,0,1-2.825,2.876,9.654,9.654,0,0,1-8.424,0,6.856,6.856,0,0,1-2.851-2.876A9.781,9.781,0,0,1,70,15.761V5.226h2.838V15.761a7.374,7.374,0,0,0,.684,3.359,4.7,4.7,0,0,0,1.884,2.026,5.371,5.371,0,0,0,2.7.68,5.247,5.247,0,0,0,2.657-.68,4.8,4.8,0,0,0,1.884-2.026,7.261,7.261,0,0,0,.7-3.359Z",
    transform: "translate(-43.466 -3.245)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_57",
    "data-name": "Trazado 57",
    d: "M127.046,23.891h-2.838V7.631h-6.219v-2.4h15.275v2.4h-6.219Z",
    transform: "translate(-73.261 -3.245)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_58",
    "data-name": "Trazado 58",
    d: "M161.96,10.031a9.44,9.44,0,0,1,2.09-3.1,9.766,9.766,0,0,1,3.135-2.065,10.5,10.5,0,0,1,7.767,0,9.775,9.775,0,0,1,3.135,2.065,9.44,9.44,0,0,1,2.09,3.1,9.8,9.8,0,0,1,.749,3.843,9.8,9.8,0,0,1-.749,3.843,9.432,9.432,0,0,1-2.09,3.1,9.761,9.761,0,0,1-3.135,2.065,10.49,10.49,0,0,1-7.767,0,9.753,9.753,0,0,1-3.135-2.065,9.432,9.432,0,0,1-2.09-3.1,9.8,9.8,0,0,1-.748-3.843,9.8,9.8,0,0,1,.748-3.843m3.083,7.542a6.735,6.735,0,0,0,2.49,2.562,7.2,7.2,0,0,0,7.069,0,6.746,6.746,0,0,0,2.49-2.562,7.434,7.434,0,0,0,.917-3.7,7.414,7.414,0,0,0-.917-3.712,6.916,6.916,0,0,0-12.05,0,7.414,7.414,0,0,0-.916,3.712,7.434,7.434,0,0,0,.916,3.7",
    transform: "translate(-100.099 -2.56)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_59",
    "data-name": "Trazado 59",
    d: "M33.614,68.467h13.76v2.659h-10.5v5.515h8.962v2.5H36.875v7.969H33.614Z",
    transform: "translate(-20.871 -42.512)",
    fill: "#ff5820"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_60",
    "data-name": "Trazado 60",
    d: "M79.374,82.943H71.2L69.55,87.114H66.093l7.83-18.647h2.733l7.829,18.647H81.043Zm-.931-2.5-3.117-8.158h-.059L72.15,80.439Z",
    transform: "translate(-41.038 -42.512)",
    fill: "#ff5820"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_61",
    "data-name": "Trazado 61",
    d: "M118.141,82.345a10.406,10.406,0,0,0,6.121,1.858q4.2-.051,4.258-2.6.031-2.086-2.807-2.509-1.3-.154-2.852-.345a7.5,7.5,0,0,1-4.226-1.779,4.592,4.592,0,0,1-1.493-3.456,4.8,4.8,0,0,1,1.875-3.943,8.038,8.038,0,0,1,5.151-1.511,13.427,13.427,0,0,1,6.982,1.927l-1.818,2.321A10.982,10.982,0,0,0,124,70.874a4.522,4.522,0,0,0-2.513.653A2.316,2.316,0,0,0,120.4,73.55a1.934,1.934,0,0,0,.724,1.459,4.45,4.45,0,0,0,2.32.922q.886.129,2.423.294a7.14,7.14,0,0,1,4.478,1.881,4.884,4.884,0,0,1,1.433,3.482q-.161,5.35-7.559,5.427A13.438,13.438,0,0,1,116,84.47Z",
    transform: "translate(-72.027 -42.261)",
    fill: "#ff5820"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_62",
    "data-name": "Trazado 62",
    d: "M166.888,70.973h-5.9V68.468h15.072v2.505h-5.908V87.114h-3.261Z",
    transform: "translate(-99.957 -42.512)",
    fill: "#ff5820"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_63",
    "data-name": "Trazado 63",
    d: "M28.624,144.658H27.115l-2.772-2.635H23.016v2.635H21.853V138.03h2.255a10.581,10.581,0,0,1,1.26.063,2.959,2.959,0,0,1,.966.289,1.968,1.968,0,0,1,.725.574,1.4,1.4,0,0,1,.268.872,1.659,1.659,0,0,1-.488,1.22,2.963,2.963,0,0,1-1.327.726ZM26.111,139.9a.98.98,0,0,0-.135-.514.991.991,0,0,0-.417-.367,1.926,1.926,0,0,0-.575-.176,5.436,5.436,0,0,0-.816-.052H23.016v2.5h1.022a5.5,5.5,0,0,0,.9-.067,1.548,1.548,0,0,0,.681-.276,1.162,1.162,0,0,0,.373-.445,1.418,1.418,0,0,0,.121-.605",
    transform: "translate(-13.569 -85.705)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_64",
    "data-name": "Trazado 64",
    d: "M49.156,144.658V138.03h5.467v.783h-4.3v1.816H54.33v.783H50.319v2.462h4.3v.783Z",
    transform: "translate(-30.522 -85.705)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_65",
    "data-name": "Trazado 65",
    d: "M80.824,144.658h-1.3l-3.864-5.715v5.715H74.569V138.03h1.65l3.518,5.248V138.03h1.086Z",
    transform: "translate(-46.301 -85.705)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_66",
    "data-name": "Trazado 66",
    d: "M103.941,144.658v-5.844H101v-.783h7.035v.783H105.1v5.844Z",
    transform: "translate(-62.715 -85.705)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_67",
    "data-name": "Trazado 67",
    d: "M144.535,144.658l2.949-6.628h1.433l2.948,6.628h-1.227l-.792-1.852H146.5l-.793,1.852Zm4.986-2.6-1.351-3.124-1.345,3.124Z",
    transform: "translate(-89.744 -85.705)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_68",
    "data-name": "Trazado 68",
    d: "M193.8,144.58a5.422,5.422,0,0,1-1.577-.218,3.529,3.529,0,0,1-1.242-.65,2.914,2.914,0,0,1-.81-1.077,3.605,3.605,0,0,1-.288-1.482,3.508,3.508,0,0,1,.279-1.451,3.079,3.079,0,0,1,.814-1.077,3.619,3.619,0,0,1,1.239-.679,5.157,5.157,0,0,1,1.6-.234,6.563,6.563,0,0,1,.825.049q.384.049.713.125c.188.044.381.1.579.166s.392.14.584.221v1.064h-.094c-.1-.072-.233-.157-.393-.258a4.155,4.155,0,0,0-.587-.3,4.59,4.59,0,0,0-.728-.227,4.117,4.117,0,0,0-.91-.089,3.186,3.186,0,0,0-1.057.174,2.537,2.537,0,0,0-.875.512,2.3,2.3,0,0,0-.575.85,3.075,3.075,0,0,0-.205,1.153,2.883,2.883,0,0,0,.218,1.173,2.378,2.378,0,0,0,1.45,1.326,3.232,3.232,0,0,0,1.045.167,4.369,4.369,0,0,0,.934-.094,4.194,4.194,0,0,0,1.321-.518c.156-.1.28-.179.37-.247h.088v1.05l-.543.2a5.817,5.817,0,0,1-.62.182q-.381.093-.707.143a5.937,5.937,0,0,1-.849.049",
    transform: "translate(-117.898 -85.507)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_69",
    "data-name": "Trazado 69",
    d: "M215.37,144.658l2.948-6.628h1.433l2.948,6.628h-1.227l-.792-1.852h-3.342l-.793,1.852Zm4.985-2.6L219,138.929l-1.345,3.124Z",
    transform: "translate(-133.726 -85.705)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_70",
    "data-name": "Trazado 70",
    d: "M251.272,144.658h-1.51l-2.771-2.635h-1.327v2.635H244.5V138.03h2.255a10.572,10.572,0,0,1,1.259.063,2.959,2.959,0,0,1,.966.289,1.975,1.975,0,0,1,.726.574,1.4,1.4,0,0,1,.267.872,1.659,1.659,0,0,1-.487,1.22,2.961,2.961,0,0,1-1.327.726Zm-2.513-4.762a.98.98,0,0,0-.135-.514.994.994,0,0,0-.417-.367,1.932,1.932,0,0,0-.576-.176,5.436,5.436,0,0,0-.816-.052h-1.151v2.5h1.022a5.5,5.5,0,0,0,.9-.067,1.544,1.544,0,0,0,.681-.276,1.168,1.168,0,0,0,.373-.445,1.423,1.423,0,0,0,.12-.605",
    transform: "translate(-151.814 -85.705)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_71",
    "data-name": "Trazado 71",
    d: "M173.456,166.374a.871.871,0,0,1-.136.484,1.09,1.09,0,0,1-.365.345,1.916,1.916,0,0,1-.582.231,3.879,3.879,0,0,1-.8.068h-1.38v-3.675h1.277q.514,0,.771.026a1.78,1.78,0,0,1,.493.122.829.829,0,0,1,.378.278.713.713,0,0,1-.06.868,1.191,1.191,0,0,1-.5.321v.02a1.281,1.281,0,0,1,.666.325.8.8,0,0,1,.236.588m-.892-1.649a.441.441,0,0,0-.058-.231.4.4,0,0,0-.188-.154,1.083,1.083,0,0,0-.346-.081q-.19-.015-.527-.015h-.614v1.076h.727A3.019,3.019,0,0,0,172,165.3a1.064,1.064,0,0,0,.294-.1.444.444,0,0,0,.207-.188.6.6,0,0,0,.061-.286m.226,1.668a.674.674,0,0,0-.077-.342.6.6,0,0,0-.314-.229,1.181,1.181,0,0,0-.331-.079q-.18-.018-.509-.017h-.727v1.358h.52a5.693,5.693,0,0,0,.663-.03,1.232,1.232,0,0,0,.426-.126.724.724,0,0,0,.265-.218.546.546,0,0,0,.084-.317",
    transform: "translate(-105.674 -101.722)",
    fill: "#ff5820"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_72",
    "data-name": "Trazado 72",
    d: "M183.728,163.826l-1.626,2.049V167.5h-.64v-1.575l-1.626-2.1h.711l1.241,1.622,1.261-1.622Z",
    transform: "translate(-111.662 -101.722)",
    fill: "#ff5820"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_73",
    "data-name": "Trazado 73",
    d: "M199.635,167.46a2.954,2.954,0,0,1-.868-.121,1.94,1.94,0,0,1-.684-.361,1.61,1.61,0,0,1-.447-.6,2.019,2.019,0,0,1-.158-.822,1.961,1.961,0,0,1,.154-.8,1.7,1.7,0,0,1,.448-.6,1.984,1.984,0,0,1,.682-.376,2.817,2.817,0,0,1,.882-.13,3.7,3.7,0,0,1,.455.027c.141.018.272.042.393.069.1.025.21.056.319.092s.216.078.321.122v.59h-.052q-.084-.059-.216-.143a2.312,2.312,0,0,0-.323-.165,2.524,2.524,0,0,0-.4-.126,2.262,2.262,0,0,0-.5-.049,1.736,1.736,0,0,0-.582.1,1.4,1.4,0,0,0-.482.284,1.265,1.265,0,0,0-.317.472,1.706,1.706,0,0,0-.114.639,1.614,1.614,0,0,0,.12.651,1.312,1.312,0,0,0,.8.736,1.767,1.767,0,0,0,.575.092,2.4,2.4,0,0,0,.514-.052,2.3,2.3,0,0,0,.728-.288c.086-.053.154-.1.2-.137h.048v.583l-.3.108a3.189,3.189,0,0,1-.341.1c-.14.035-.27.061-.39.079a3.282,3.282,0,0,1-.467.027",
    transform: "translate(-122.617 -101.613)",
    fill: "#ff5820"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_74",
    "data-name": "Trazado 74",
    d: "M208.055,167.5l1.623-3.676h.788l1.624,3.676h-.676l-.436-1.027h-1.84L208.7,167.5Zm2.744-1.444-.743-1.732-.74,1.732Z",
    transform: "translate(-129.184 -101.722)",
    fill: "#ff5820"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_75",
    "data-name": "Trazado 75",
    d: "M224.36,167.5h-.831L222,166.04h-.73V167.5h-.64v-3.676h1.242a5.881,5.881,0,0,1,.694.035,1.621,1.621,0,0,1,.531.161,1.083,1.083,0,0,1,.4.318.779.779,0,0,1,.147.483.924.924,0,0,1-.268.677,1.627,1.627,0,0,1-.73.4Zm-1.383-2.641a.517.517,0,0,0-.3-.489,1.062,1.062,0,0,0-.317-.1,2.967,2.967,0,0,0-.449-.028h-.633v1.387h.562a3.005,3.005,0,0,0,.5-.037.853.853,0,0,0,.375-.153.648.648,0,0,0,.205-.246.8.8,0,0,0,.066-.336",
    transform: "translate(-136.994 -101.722)",
    fill: "#ff5820"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76",
    "data-name": "Trazado 76",
    d: "M233.155,167.46a4.123,4.123,0,0,1-.891-.083,5.237,5.237,0,0,1-.69-.2v-.612h.046a2.492,2.492,0,0,0,.718.352,2.614,2.614,0,0,0,.773.125,1.536,1.536,0,0,0,.8-.169.507.507,0,0,0,.271-.445.477.477,0,0,0-.142-.358.92.92,0,0,0-.452-.205q-.223-.049-.408-.081c-.122-.021-.277-.05-.462-.086a2.652,2.652,0,0,1-.446-.126,1.3,1.3,0,0,1-.35-.2.872.872,0,0,1-.231-.285.835.835,0,0,1-.083-.379.882.882,0,0,1,.456-.749,2.064,2.064,0,0,1,1.163-.3,4.518,4.518,0,0,1,.765.062,3.718,3.718,0,0,1,.668.175v.585h-.049a2.313,2.313,0,0,0-.588-.28,2.373,2.373,0,0,0-.753-.12,1.429,1.429,0,0,0-.721.159.475.475,0,0,0-.275.419.465.465,0,0,0,.161.372,1.042,1.042,0,0,0,.469.2q.2.042.5.1t.488.1a1.468,1.468,0,0,1,.727.351.791.791,0,0,1,.23.577.879.879,0,0,1-.115.425,1.044,1.044,0,0,1-.322.355,1.834,1.834,0,0,1-.525.247,2.63,2.63,0,0,1-.732.086",
    transform: "translate(-143.787 -101.613)",
    fill: "#ff5820"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_77",
    "data-name": "Trazado 77",
    d: "M245.622,164.123a1.628,1.628,0,0,1,.426.6,2.066,2.066,0,0,1,.152.817,2.093,2.093,0,0,1-.149.807,1.587,1.587,0,0,1-.43.605,1.886,1.886,0,0,1-.687.379,2.91,2.91,0,0,1-.865.122,2.869,2.869,0,0,1-.88-.126,1.863,1.863,0,0,1-.672-.375,1.616,1.616,0,0,1-.427-.6,2.092,2.092,0,0,1-.149-.81,2.053,2.053,0,0,1,.15-.814,1.712,1.712,0,0,1,.428-.6,1.874,1.874,0,0,1,.671-.372,2.839,2.839,0,0,1,.878-.127,2.807,2.807,0,0,1,.886.131,1.914,1.914,0,0,1,.666.368m-.087,1.417a1.873,1.873,0,0,0-.1-.646,1.259,1.259,0,0,0-.291-.467,1.215,1.215,0,0,0-.461-.285,2.015,2.015,0,0,0-1.215,0,1.261,1.261,0,0,0-.461.287,1.238,1.238,0,0,0-.293.472,1.9,1.9,0,0,0-.1.642,1.466,1.466,0,1,0,2.926,0",
    transform: "translate(-150.226 -101.596)",
    fill: "#ff5820"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_78",
    "data-name": "Trazado 78",
    d: "M259.2,167.5h-.718l-2.127-3.169V167.5h-.6v-3.675h.908l1.937,2.91v-2.91h.6Z",
    transform: "translate(-158.805 -101.722)",
    fill: "#ff5820"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_79",
    "data-name": "Trazado 79",
    d: "M356.852,46.865l19.092-2.875s.387-3.857,3.4-2.929,3.637,4.024,4.256,6.268a39.794,39.794,0,0,1,1.547,10.523c.155,5.339,0,14.392,0,14.392h1.7V53.52a28.79,28.79,0,0,0-2.709-9.529c-2.476-5.328-4.72-5.947-6.422-6.256a51.735,51.735,0,0,0-7.042,0Z",
    transform: "translate(-221.574 -23.345)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_80",
    "data-name": "Trazado 80",
    d: "M244.942,63.181l48.207-.928s7.042-.464,10.369-.7,4.72.309,5.726,2.4.851,5.347.619,7.393l-18.958.009-2.94-3.689,3.4,2.708,15.4-.077s.309-4.333-1.238-5.107c0,0-.232-.232-2.244-.232s-58.343-1.78-58.343-1.78",
    transform: "translate(-152.088 -38.19)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_81",
    "data-name": "Trazado 81",
    d: "M375.986,97.034l15.785-.7s1.238,4.1.387,6.732-1.857,3.482-2.786,3.56-12.767-.387-12.767-.387,9.6-.464,10.369-.7a4.427,4.427,0,0,0,3.173-4.058,16.574,16.574,0,0,0-.232-3.989Z",
    transform: "translate(-233.455 -59.818)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_82",
    "data-name": "Trazado 82",
    d: "M84.962,86.268l45.421-.748s8.821,6.345,9.44,9.982-.077,6.5-7.274,6.5S0,100.067,0,100.067l133.555-.146s3.482.146,4.024-1.247.851-2.786-1.547-5.262-6.345-6.19-6.345-6.19Z",
    transform: "translate(0 -53.1)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_83",
    "data-name": "Trazado 83",
    d: "M222.568,12.814,286.2,14.253V11.34s.482-1.928,1.786-2.041,7.314,0,7.314,0,.778.056.843.4-.162.51-2.43,1.361-3.175,1.248-3.175,1.248l6.294-.553a2.228,2.228,0,0,0,1.134-1.2,1.8,1.8,0,0,0-.4-2.154l-.794-.907h-9.185s.17.85-1.644.907-2.211.056-2.211.056-.737-2.325-4.252-5.1a30.5,30.5,0,0,0-4.2-3.062h-5.5C263.663.284,231.855,0,231.855,0l41.618,1.928a5.182,5.182,0,0,1,2.323,1.3c1.417,1.191,2.948,2.835,6.577,9.128Z",
    transform: "translate(-138.195)",
    fill: "#212121"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutofast);
export default __webpack_public_path__ + "static/media/autofast.91d14943328cd0ced89993e7ed037853.svg";
export { ForwardRef as ReactComponent };